export default "__VITE_PUBLIC_ASSET__23ab1410__"